import React from 'react';
import { WALLET_CURRENCY_SYMBOLS } from 'constants/wallet';
import { CorpAccountIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

// Shown in place of Add funds once a wallet is frozen or closed: nothing can be loaded any more,
// so the card only states what the wallet is.
const WalletDetails = ({ walletName, currency }) => {
  const { translateText } = useTranslation();
  const currencyCode = String(currency ?? '').toUpperCase();
  // The create-wallet form already has the "GBP — Pound" style labels; reuse them for known currencies.
  const currencyLabel = WALLET_CURRENCY_SYMBOLS[currencyCode.toLowerCase()]
    ? translateText(`corporateAccounts.wallet.create.currency.${currencyCode}`)
    : currencyCode;

  return (
    <div className={styles.card} data-testid="walletDetails">
      <div className={styles.cardHeader}>
        <span className={styles.cardHeaderIcon}>
          <CorpAccountIcon />
        </span>
        {translateText('corporateAccounts.wallet.dashboard.walletDetails.title')}
      </div>
      <div className={styles.cardBody}>
        <dl className={styles.walletDetailsList}>
          <div className={styles.walletDetailsRow} data-testid="walletDetailsName">
            <dt className={styles.walletDetailsLabel}>
              {translateText('corporateAccounts.wallet.dashboard.walletDetails.name')}
            </dt>
            <dd className={styles.walletDetailsValue}>{walletName}</dd>
          </div>
          <div className={styles.walletDetailsRow} data-testid="walletDetailsCurrency">
            <dt className={styles.walletDetailsLabel}>
              {translateText('corporateAccounts.wallet.dashboard.walletDetails.currency')}
            </dt>
            <dd className={styles.walletDetailsValue}>{currencyLabel}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default WalletDetails;
